import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { H4, Stack, useTheme } from '@qred/components-library';
import React from 'react';
import useTranslate from '~/hooks/useTranslate';
import {
  GoldenRatioContainer,
  StandardPageContainer,
} from '~/styles/BaseStyledComponents';
import { DotsStepper } from '../DotsStepper/DotsStepper';
import { ProgressBar } from '../ProgressBar/ProgressBar';
import { CardApplicationResult } from './components/CardApplicationResult';
import { useCardApplicationWebSocket } from './hooks/useCardApplicationWebSocket/useCardApplicationWebSocket';
import { useFakeProgress } from './hooks/useFakeProgress/useFakeProgress';

const LOTTIE_SRC = '/company_info.lottie';

const steps: Array<{ title: string }> = [
  {
    title: 'Onboarding.AutoProcessingStep1Title',
  },
  {
    title: 'Onboarding.AutoProcessingStep2Title',
  },
  {
    title: 'Onboarding.AutoProcessingStep3Title',
  },
  {
    title: 'Onboarding.AutoProcessingStep4Title',
  },
];

type Props = {
  applicationUuid: string;
  clientId: number;
};

export const ProcessingApplication = ({ clientId, applicationUuid }: Props) => {
  const theme = useTheme();
  const t = useTranslate();

  const { status } = useCardApplicationWebSocket(applicationUuid);
  const { currentStep, progress } = useFakeProgress(
    steps.length,
    status !== null
  );
  const isAutoApprovalComplete = status !== null && progress >= 100;

  const { title } = steps[currentStep];

  if (isAutoApprovalComplete) {
    return <CardApplicationResult status={status} clientId={clientId} />;
  }

  return (
    <StandardPageContainer
      style={{
        backgroundColor: theme.fn.themeColor('Container/Option_2_(White)'),
        maxWidth: '600px',
        padding: `0 ${theme.spacing.xxl}`,
        margin: '0 auto',
      }}
      data-testid="card_application_confirmation_page"
    >
      <GoldenRatioContainer style={{ width: '100%' }}>
        <Stack align="center" spacing="xxl">
          <H4 color="Text/Headlines_(Brand)">
            {t('Onboarding.AutoProcessingTitle')}
          </H4>
          <DotLottieReact
            style={{ width: '160px', height: '160px' }}
            src={LOTTIE_SRC}
            loop
            autoplay
          />
          <DotsStepper
            title={t(title) as string}
            currentStep={currentStep}
            totalSteps={steps.length}
          />
          <ProgressBar
            label={t('Onboarding.AutoProcessingProgressLabel') as string}
            progress={progress}
          />
        </Stack>
      </GoldenRatioContainer>
    </StandardPageContainer>
  );
};
